import { getConfluenceContentAri } from '@confluence/content-types-utils/entry-points/getConfluenceContentAri.ts';

export const getAutohighlightsQueryVariables = ({
	contentId,
	cloudId,
	activationId,
	contentType,
}: {
	contentId: string;
	cloudId: string;
	activationId: string;
	contentType: string;
}): {
	entityAri: string;
	workspaceId: string;
} => ({
	entityAri: getConfluenceContentAri({
		siteId: cloudId,
		resourceType: contentType,
		resourceId: contentId,
		activationId: '',
	}),
	workspaceId: getConfluenceContentAri({
		siteId: cloudId,
		resourceType: 'workspace',
		resourceId: activationId,
		activationId: '',
	}),
});
